/*
  Light header's desktop dropdowns (snippets/header-nav-refined.liquid).
  - Hover or keyboard focus opens an item's panel; leaving closes it after a
    short delay, so crossing the gap between link and panel doesn't flicker.
  - Touch screens (e.g. iPad landscape): the first tap on a link opens its
    panel, the second follows the link.
  - Escape closes the open panel and returns focus to its link.
  - While a panel is open the header gets .header-refined--open (square
    bottom corners, so bar and panel read as one card).
*/
(function () {
  var CLOSE_DELAY = 160;

  function init() {
    var header = document.querySelector('#SiteHeader.site-header--refined');
    if (!header) return;

    var items = Array.prototype.slice.call(header.querySelectorAll('[data-hr-item]'));
    var openItem = null;
    var closeTimer = null;

    function trigger(item) {
      return item.querySelector('[data-hr-trigger]');
    }

    function open(item) {
      clearTimeout(closeTimer);
      if (openItem === item) return;
      if (openItem) close(openItem);
      openItem = item;
      item.classList.add('is-open');
      trigger(item).setAttribute('aria-expanded', 'true');
      header.classList.add('header-refined--open');
    }

    function close(item) {
      item.classList.remove('is-open');
      trigger(item).setAttribute('aria-expanded', 'false');
      if (openItem === item) {
        openItem = null;
        header.classList.remove('header-refined--open');
      }
    }

    function closeLater(item) {
      clearTimeout(closeTimer);
      closeTimer = setTimeout(function () {
        close(item);
      }, CLOSE_DELAY);
    }

    items.forEach(function (item) {
      item.addEventListener('mouseenter', function () {
        open(item);
      });
      item.addEventListener('mouseleave', function () {
        closeLater(item);
      });
      item.addEventListener('focusin', function () {
        open(item);
      });
      item.addEventListener('focusout', function (event) {
        if (!item.contains(event.relatedTarget)) close(item);
      });

      trigger(item).addEventListener('click', function (event) {
        var coarse = window.matchMedia && window.matchMedia('(hover: none)').matches;
        if (coarse && !item.classList.contains('is-open')) {
          event.preventDefault();
          open(item);
        }
      });
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape' || !openItem) return;
      var item = openItem;
      close(item);
      trigger(item).focus();
    });

    // A tap outside the header closes an open panel on touch screens.
    document.addEventListener(
      'touchstart',
      function (event) {
        if (openItem && !header.contains(event.target)) close(openItem);
      },
      { passive: true }
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/*
  Light header's cart count badge (sections/header.liquid, cart_icon).
  assets/custom.js re-renders #cart-drawer after every cart change (add,
  remove, quantity, free gifts), so a change there - or the aiza:cart:updated
  event it fires on main - re-reads the count from /cart.js.
*/
(function () {
  function init() {
    var badges = document.querySelectorAll('#SiteHeader.site-header--refined [data-hr-cart-count]');
    // Desktop "BAG (n)" label.
    var labels = document.querySelectorAll('#SiteHeader.site-header--refined [data-hr-cart-count-text]');
    if (!badges.length && !labels.length) return;

    function setCount(itemCount) {
      if (typeof itemCount !== 'number') return;
      badges.forEach(function (badge) {
        badge.textContent = itemCount > 99 ? '99+' : String(itemCount);
        badge.classList.toggle('is-empty', itemCount === 0);
      });
      labels.forEach(function (label) {
        label.textContent = String(itemCount);
      });
    }

    var timer = null;
    function refresh() {
      clearTimeout(timer);
      timer = setTimeout(function () {
        fetch('/cart.js', { headers: { Accept: 'application/json' } })
          .then(function (res) {
            return res.json();
          })
          .then(function (cart) {
            setCount(cart.item_count);
          })
          .catch(function () {});
      }, 150);
    }

    document.addEventListener('aiza:cart:updated', function (e) {
      if (e.detail && typeof e.detail.itemCount === 'number') {
        setCount(e.detail.itemCount);
      } else {
        refresh();
      }
    });
    document.addEventListener('theme:cart:added', refresh);

    var drawer = document.getElementById('cart-drawer');
    if (drawer) new MutationObserver(refresh).observe(drawer, { childList: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/*
  Light header's language dropdown (sections/header.liquid, header_language_list):
  the current language and a caret, opening EN / عربي. Choosing one is handled
  by assets/custom.js (.disclosure__link clicks); this only opens and closes
  the list - on click, outside click and Escape.
*/
(function () {
  function init() {
    var wrap = document.querySelector('#SiteHeader.site-header--refined [data-hr-lang]');
    if (!wrap) return;
    var toggle = wrap.querySelector('[data-hr-lang-toggle]');
    var list = wrap.querySelector('[data-hr-lang-list]');
    if (!toggle || !list) return;

    function setOpen(open) {
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      list.hidden = !open;
      wrap.classList.toggle('is-open', open);
    }

    toggle.addEventListener('click', function (e) {
      e.preventDefault();
      setOpen(list.hidden);
    });

    list.addEventListener('click', function (e) {
      if (e.target.closest('.disclosure__link')) setOpen(false);
    });

    document.addEventListener('click', function (e) {
      if (!list.hidden && !wrap.contains(e.target)) setOpen(false);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !list.hidden) {
        setOpen(false);
        toggle.focus();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
